import React from 'react';
import { Button, Icons, Typography } from '@hmsexp/component-library';
import styles from './styles';
import { View } from '../react-native-components';

function GenericNoData(props) {
  const {
    icon,
    title = 'No Data',
    subTitle = "We couldn't find any data to display at the moment",
    actionComponant,
    renderActionButton = false,
    actionButtonProps = {},
    actionButtonText = 'Refresh'
  } = props;

  return (
    <View style={styles.genericNoDataCardContainer}>
      <View style={styles.genericNoDataIconContainer}>
        <Icons.ReportsIcon size='XL' />
      </View>
      <Typography variant='h6' fontWeightType='bold' color='primaryContentHigh' textProps={{ style: styles.titleText }}>
        {title}
      </Typography>
      <Typography variant='button' fontWeightType='regular' textProps={{ style: styles.noDataSubTitleText }}>
        {subTitle}
      </Typography>

      {renderActionButton && (
        <Button
          style={{
            buttonContainer: styles.noDataActionButtonContainer,
            buttonText: styles.buttonText
          }}
          title={actionButtonText}
          outlined
          {...actionButtonProps}
        />
      )}
      {actionComponant && actionComponant()}
    </View>
  );
}
export default GenericNoData;
